import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { onError } from 'apollo-link-error';
import { ApolloClient } from 'apollo-client';
import { tokenAuthenticator } from '../tokenAuthenticator';
import { ApolloLink, concat } from 'apollo-link';
import { createUploadLink } from 'apollo-upload-client';
import getEnv from '@/env-util';

// Authentication
const authMiddleware = new ApolloLink((operation, forward) => {
  const token = tokenAuthenticator.getToken();
  if (token) {
    operation.setContext({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  return forward(operation);
});

// Error Handling
const errorMiddleware = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );

  if (networkError) console.log(`[Network error]: ${networkError}`);
});

// Create client links
let credentials = 'include';
const httpLinkAuthentication = createUploadLink({
  uri: getEnv('VUE_APP_AUTHENTICATION_URL'),
  credentials: credentials,
});

const httpLinkUpgradePackage = createUploadLink({
  uri: getEnv('VUE_APP_UPGRADE_PACKAGE_URL'),
  credentials: credentials,
});

const httpLinkTargetScoringDefinition = createUploadLink({
  uri: getEnv('VUE_APP_TARGET_SCORING_DEFINITION_URL'),
  credentials: credentials,
});

const httpLinkShootingProgram = createUploadLink({
  uri: getEnv('VUE_APP_SHOOTING_PROGRAM_URL'),
  credentials: credentials,
});

const httpLinkOrganization = createUploadLink({
  uri: getEnv('VUE_APP_ORGANIZATION_URL'),
  credentials: credentials,
});

const httpLinkLicense = createUploadLink({
  uri: getEnv('VUE_APP_LICENSE_URL'),
  credentials: credentials,
});

const httpLinkResult = createUploadLink({
  uri: getEnv('VUE_APP_RESULT_URL'),
  credentials: credentials,
});

const httpLinkOwnerManagement = createUploadLink({
  uri: getEnv('VUE_APP_OWNER_MANAGEMENT_URL'),
  credentials: credentials,
});

const httpLinkPayment = createUploadLink({
  uri: getEnv('VUE_APP_PAYMENT_URL'),
  credentials: credentials,
});

const linkAuthentication = errorMiddleware.concat(
  concat(authMiddleware, httpLinkAuthentication)
);
const linkUpgradePackage = errorMiddleware.concat(
  concat(authMiddleware, httpLinkUpgradePackage)
);
const linkTargetScoringDefinition = errorMiddleware.concat(
  concat(authMiddleware, httpLinkTargetScoringDefinition)
);
const linkShootingProgram = errorMiddleware.concat(
  concat(authMiddleware, httpLinkShootingProgram)
);
const linkOrganization = errorMiddleware.concat(
  concat(authMiddleware, httpLinkOrganization)
);
const linkLicense = errorMiddleware.concat(
  concat(authMiddleware, httpLinkLicense)
);
const linkResult = errorMiddleware.concat(
  concat(authMiddleware, httpLinkResult)
);
const linkOwnerManagement = errorMiddleware.concat(
  concat(authMiddleware, httpLinkOwnerManagement)
);
const linkPayment = errorMiddleware.concat(
  concat(authMiddleware, httpLinkPayment)
);

// Create the apollo clients
export const authenticationClient = new ApolloClient({
  link: linkAuthentication,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

export const upgradePackageClient = new ApolloClient({
  link: linkUpgradePackage,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

export const targetScoringDefinitionClient = new ApolloClient({
  link: linkTargetScoringDefinition,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

export const shootingProgramClient = new ApolloClient({
  link: linkShootingProgram,
  cache: new InMemoryCache({
    addTypename: false,
  }),
  connectToDevTools: true,
});

export const organizationClient = new ApolloClient({
  link: linkOrganization,
  cache: new InMemoryCache({
    addTypename: false,
  }),
  connectToDevTools: true,
});

export const licenseClient = new ApolloClient({
  link: linkLicense,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

export const resultClient = new ApolloClient({
  link: linkResult,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

export const ownerManagementClient = new ApolloClient({
  link: linkOwnerManagement,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

export const paymentClient = new ApolloClient({
  link: linkPayment,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  clients: {
    authenticationClient,
    upgradePackageClient,
    targetScoringDefinitionClient,
    shootingProgramClient,
    organizationClient,
    licenseClient,
    resultClient,
    ownerManagementClient,
    paymentClient,
  },
  defaultClient: authenticationClient,
});

export default apolloProvider;
